import React, { useState } from "react";
import { func } from "prop-types";
import { connect } from "react-redux";

import { register, verifyEmail } from "../../helper/api";
import { isValidEmail } from "../../helper/utils";
import { setLoading } from "../../helper/actions";

import TextField from "../../atoms/textfield";
import Checkbox from "../../atoms/checkbox";
import Button from "../../atoms/button";
import ErrorView from "../../molecules/error-view";
import SuccessView from "../../molecules/success-view";

import "./signup.m.css";

const SERVER_ERROR = "Oops! Something went wrong";
const VERIFY_EMAIL_MESSAGE = "Please do the Email Verification to complete the Registration!";

const SignUp = ({ setLoading }) => {
  const [error, setError] = useState(null);
  const [successMessage, setSuccessMessage] = useState(null);
  const [user, setUser] = useState({
    name: "",
    email: "",
    password: "",
    repeatPassword: "",
    isPolicyAccepted: false
  });

  const setData = e => {
    const userObj = { ...user };
    const fieldName = e.target.name;
    userObj[fieldName] = e.target.value;

    // If error has been set then remove it
    if (e.target.value && userObj[`${fieldName}Error`]) {
      userObj[`${fieldName}Error`] = "";
    }

    // If error is set remove it since data is changed
    if (error) {
      setError(null);
    }

    // If success message is set remove it since data is changed
    if (successMessage) {
      setSuccessMessage(null);
    }

    setUser(userObj);
  };

  const onCheckboxClick = e => {
    setUser({ ...user, isPolicyAccepted: e.target.checked });

    // If checked and error is set then remove it
    if (e.target.checked) {
      if (error) setError(null);
    }

    // If success message is set then remove it
    if (successMessage) {
      setSuccessMessage(null);
    }
  };

  const onSubmitClick = event => {
    event.preventDefault();

    if (validate()) {
      // true -> field errors, false - no fields errors
      return;
    }

    const userObj = {
      "send-welcome-email-delay": 0,
      name: user.name,
      email: user.email,
      username: user.name,
      password: user.password,
      "dont-login": true,
      metadata: {
        isPolicyAccepted: user.isPolicyAccepted
      }
    };

    setLoading(true);

    register(userObj)
      .then(response => verifyEmail(response.member.email))
      .then(() => {
        // Reset fields
        setUser({
          name: "",
          email: "",
          password: "",
          repeatPassword: "",
          isPolicyAccepted: false
        });
        setLoading(false);
        setSuccessMessage(VERIFY_EMAIL_MESSAGE);
      })
      .catch(err => {
        if (err.status === 409) {
          setError(`The email '${userObj.email}' already exists`);
        } else {
          setError(SERVER_ERROR);
        }
        setLoading(false);
      });
  };

  const validate = () => {
    const updatedUser = { ...user };
    let flag = false;

    // If success message is set then remove it
    if (successMessage) {
      setSuccessMessage(null);
    }

    if (!updatedUser.name) {
      updatedUser.nameError = "Name field cannot be left blank!";
      flag = true;
    } else {
      updatedUser.nameError = "";
    }

    if (!updatedUser.email) {
      updatedUser.emailError = "Email field cannot be left blank!";
      flag = true;
    } else if (!isValidEmail(updatedUser.email)) {
      updatedUser.emailError = "Invalid Email !!";
      flag = true;
    } else {
      updatedUser.emailError = "";
    }

    if (!updatedUser.password) {
      updatedUser.passwordError = "Password field cannot be left blank!";
      flag = true;
    } else {
      updatedUser.passwordError = "";
    }

    if (!updatedUser.repeatPassword) {
      updatedUser.repeatPasswordError = "Password field cannot be left blank!";
      flag = true;
    } else {
      updatedUser.repeatPasswordError = "";
    }

    if (!updatedUser.isPolicyAccepted) {
      flag = true;
      setError("Accept the Private Policy!");
    } else {
      setError(null);
    }

    if (updatedUser.password && updatedUser.repeatPassword) {
      // If password's exists then check if both are same
      if (updatedUser.password !== updatedUser.repeatPassword) {
        setError("Password and Repeat Password do not match");
        flag = true;
      }
    }

    // If flag is true, there are field error's
    if (flag) {
      setUser(updatedUser); // update state with field errors
    }

    return flag;
  };

  return (
    <form onSubmit={onSubmitClick}>
      <div styleName="wrapper">
        <ErrorView error={error} closeClick={() => setError(null)} />
        <SuccessView text={successMessage} closeClick={() => setSuccessMessage(null)} />
        <TextField
          value={user.name}
          error={user.nameError}
          placeholder="Who Are You"
          label="Full Name"
          name="name"
          onChange={setData}
        />
        <TextField
          value={user.email}
          error={user.emailError}
          placeholder="who@areyou.com"
          label="Email"
          type="email"
          name="email"
          onChange={setData}
        />
        <TextField
          value={user.password}
          error={user.passwordError}
          placeholder="password"
          label="Password"
          type="password"
          name="password"
          onChange={setData}
        />
        <TextField
          value={user.repeatPassword}
          error={user.repeatPasswordError}
          placeholder="repeat password"
          label="Repeat Password"
          type="password"
          name="repeatPassword"
          onChange={setData}
        />
        <Checkbox
          text="By clicking Register, you agree to our Data Policy & Cookie Policy."
          isChecked={user.isPolicyAccepted}
          onClick={onCheckboxClick}
        />
        <Button content="REGISTER" type="submit" />
      </div>
    </form>
  );
};

SignUp.propTypes = {
  setLoading: func
};

const mapDispatchToProps = dispatch => ({
  setLoading: isLoading => dispatch(setLoading(isLoading))
});

export default connect(
  null,
  mapDispatchToProps
)(SignUp);
